import propTypes from 'prop-types';
import * as S from './styles';

const HeroCard = ({ variant, icon, title, children, compact }) => (
  <S.HeroCard $variant={variant} $compact={compact}>
    <S.HeroIcon $variant={variant} $compact={compact}>
      {icon}
    </S.HeroIcon>
    <S.HeroTitle>{title}</S.HeroTitle>
    <S.HeroText>{children}</S.HeroText>
  </S.HeroCard>
);

HeroCard.propTypes = {
  variant: propTypes.oneOf(['info', 'success', 'danger']),
  icon: propTypes.node.isRequired,
  title: propTypes.string.isRequired,
  children: propTypes.node.isRequired,
  compact: propTypes.bool,
};

HeroCard.defaultProps = {
  variant: 'info',
  compact: false,
};

export default HeroCard;
